export default __webpack_public_path__ + "static/image 58-cf01db076b8fbdd9a804ea4b2594a081.png";